import React, { Component } from 'react';
import {Button} from 'react-materialize'
import {Link} from 'react-router-dom'

import './Home.css'
import './Header.css'

class Home extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
      <div>
        <header className="header_main">
          <div className="header_item">
            <h1 className="amber-text text-darken-4">How To Own Your Next Style</h1>
            <h2 className="deep-orange-text text-darken-4">New Style. New Look. New You.</h2>
            <Button className="btn_primary btn_primary-header" waves="light">Find a Hair Style</Button>
          </div>
        </header>

        <section role="main" className="home_grid">
          <div className="home_item-a"></div>
          <div className="home_item-b amber darken-4"><div><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur commodo ornare lectus at molestie. Mauris cursus ex mi, id porta nunc consectetur nec. Morbi id suscipit elit, non porttitor dui. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Suspendisse mollis leo ut quam faucibus laoreet.</p></div></div>
          <div className="home_item-c deep-orange darken-4"><div><h5>Lorem Ipsum</h5><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur commodo ornare lectus at molestie. Mauris cursus ex mi.</p></div></div>
          <div className="home_item-d"></div>
          <div className="home_item-e black"><div><h4>Stop Looking for a New Look. Schedule an Appointment with our Experts Today</h4><Link className="btn waves-effect waves-orange btn_primary btn_primary-action" to="/schedule">Make Appointment</Link></div></div>
          <div className="home_item-f"></div>
          <div className="home_item-g deep-orange darken-4"><div><h4>We Offer Professional Quality Products</h4></div></div>
          <div className="home_item-h amber darken-4"><div><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur commodo ornare lectus at molestie. Mauris cursus ex mi, id porta nunc consectetur nec. Morbi id suscipit elit, non porttitor dui. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Suspendisse mollis leo ut quam faucibus laoreet.</p></div></div>
          <div className="home_item-i"></div>
          <div className="home_item-j"></div>
          <div className="home_item-k black"><div><h4>Need a Haircut?</h4><Link className="btn waves-effect waves-orange btn_primary btn_primary-action" to="/contact">Visit Us</Link></div></div>
          <div className="home_item-l"></div>
        </section>
      </div>
    );
  }
}

export default Home
